'use strict';
import * as $j_app$002eapi$002e$002dUnauthenticated$002dApp$002dUpdate$0024$002dInitialize from "./app.api.-Unauthenticated-App-Update$-Initialize.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_UnauthenticatedAppUpdate$Initialize$() {
}
export { $c_Lapp_api_UnauthenticatedAppUpdate$Initialize$ as $c_Lapp_api_UnauthenticatedAppUpdate$Initialize$ };
$c_Lapp_api_UnauthenticatedAppUpdate$Initialize$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_UnauthenticatedAppUpdate$Initialize$.prototype.constructor = $c_Lapp_api_UnauthenticatedAppUpdate$Initialize$;
/** @constructor */
function $h_Lapp_api_UnauthenticatedAppUpdate$Initialize$() {
}
export { $h_Lapp_api_UnauthenticatedAppUpdate$Initialize$ as $h_Lapp_api_UnauthenticatedAppUpdate$Initialize$ };
$h_Lapp_api_UnauthenticatedAppUpdate$Initialize$.prototype = $c_Lapp_api_UnauthenticatedAppUpdate$Initialize$.prototype;
$c_Lapp_api_UnauthenticatedAppUpdate$Initialize$.prototype.toString__T = (function() {
  return "Initialize";
});
$c_Lapp_api_UnauthenticatedAppUpdate$Initialize$.prototype.fromProduct__s_Product__Lapp_api_UnauthenticatedAppUpdate$Initialize = (function(x$0) {
  var serverInProductionMode$1 = (!(!x$0.productElement__I__O(0)));
  return new $j_app$002eapi$002e$002dUnauthenticated$002dApp$002dUpdate$0024$002dInitialize.$c_Lapp_api_UnauthenticatedAppUpdate$Initialize(serverInProductionMode$1);
});
$c_Lapp_api_UnauthenticatedAppUpdate$Initialize$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_api_UnauthenticatedAppUpdate$Initialize(p);
});
var $d_Lapp_api_UnauthenticatedAppUpdate$Initialize$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_UnauthenticatedAppUpdate$Initialize$, "app.api.UnauthenticatedAppUpdate$Initialize$", ({
  Lapp_api_UnauthenticatedAppUpdate$Initialize$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_api_UnauthenticatedAppUpdate$Initialize$ as $d_Lapp_api_UnauthenticatedAppUpdate$Initialize$ };
var $n_Lapp_api_UnauthenticatedAppUpdate$Initialize$;
function $m_Lapp_api_UnauthenticatedAppUpdate$Initialize$() {
  if ((!$n_Lapp_api_UnauthenticatedAppUpdate$Initialize$)) {
    $n_Lapp_api_UnauthenticatedAppUpdate$Initialize$ = new $c_Lapp_api_UnauthenticatedAppUpdate$Initialize$();
  }
  return $n_Lapp_api_UnauthenticatedAppUpdate$Initialize$;
}
export { $m_Lapp_api_UnauthenticatedAppUpdate$Initialize$ as $m_Lapp_api_UnauthenticatedAppUpdate$Initialize$ };
//# sourceMappingURL=app.api.-Unauthenticated-App-Update$-Initialize$.js.map
